import Components from "../javascripts/components";
import URL from "hb/lib/url";

URL.checkForInternalPushstateRefresh();

// Called once after the initial page has loaded
document.addEventListener("turbo:load", () => Components.collection.loadAll(), {
  once: true,
});

// Called after every turbo XHR-fetched page is rendered
document.addEventListener("turbo:render", () => {
  $.rails.refreshCSRFTokens();
  Components.collection.loadAll();
});

// Called after turbo frames are replaced
document.addEventListener("turbo:frame-render", (event) => {
  if (event.target) {
    Components.collection.loadFragment(event.target);
  }
});

// Called after turbo frame loads complete
document.addEventListener("turbo:frame-load", (event) => {
  if (event.target) {
    Components.collection.loadFragment(event.target);
  }
});

// Called after turbo morph is complete
document.addEventListener("turbo:morph", (event) => {
  if (event.target) {
    Components.collection.loadFragment(event.target);
  }
});

// Called after turbo morph-element is complete
document.addEventListener("turbo:morph-element", (event) => {
  if (event.target) {
    Components.collection.loadFragment(event.target);
  }
});

// Called after turbo stream actions complete
document.addEventListener("turbo:before-stream-render", () => {
  // Use a small delay to ensure the stream has rendered to the DOM
  setTimeout(() => {
    Components.collection.unloadAll();
    Components.collection.loadAll();
  }, 10);
});

// Called before every turbo XHR-fetched page is rendered
document.addEventListener("turbo:before-render", () => {
  Components.collection.unloadAll();
});

document.addEventListener("turbo:before-cache", () => {
  // Manually tear down bootstrap modals before caching. If turbo
  // caches the modal then tries to restore it, it breaks bootstrap's JS.
  // We can't just use bootstrap's `modal('close')` method because it is async.
  // Turbo will cache the page before it finishes running.
  if (document.body.classList.contains("modal-open")) {
    $(".modal").hide().removeAttr("aria-modal").attr("aria-hidden", "true");
    $(".modal-backdrop").remove();
    $("body").removeClass("modal-open");
  }

  // Remove the heroku widget before caching. Heroku's js doesn't check for its existence
  // before creating a new one, so if you visit a cached page 5x you'll end up with 5
  // widgets on the page.
  if (document.body.classList.contains("heroku-boomerang-loaded")) {
    $(".boomerang").remove();
    $("body").removeClass("heroku-boomerang-loaded");
  }

  // Remove profitwell retain's iframe before caching
  const profitWellFrame = document.getElementById("__pw_frame");
  if (profitWellFrame) {
    profitWellFrame.remove();
  }
});
